import { render, staticRenderFns } from "./SortedCards.vue?vue&type=template&id=a0df3560&"
import script from "./SortedCards.vue?vue&type=script&lang=js&"
export * from "./SortedCards.vue?vue&type=script&lang=js&"
import style0 from "./SortedCards.vue?vue&type=style&index=0&id=a0df3560&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports